import EditIcon from '@mui/icons-material/Edit';
import React, {Dispatch, SetStateAction, useState} from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import {Avatar, ListItemAvatar} from "@mui/material";
import ListItemText from "@mui/material/ListItemText";
import ProductEdit from "./ProductEdit.tsx";
import {EditProduct, Product} from "./uc/domain.ts"

interface ProductsProps {
    products: Array<Product>
    // updateProducts: () => void
    setCurrentEditProduct: (productRef: string|null, qty?:number) => Promise<void>
    currentEditProduct: EditProduct|null
}

const Products: React.FC<ProductsProps> = (props) => {
    return <>
        <ProductEdit editableProduct={props.currentEditProduct} setCurrentEditProduct={props.setCurrentEditProduct}/>
        <List>
            {props.products.map((product: Product) => (
                <ListItem key={product.id}>
                    <ListItemAvatar onClick={() => {
                        if (product.id) {
                            props.setCurrentEditProduct(product.id, product.quantity).then()
                        }
                    }}>
                        <Avatar>
                            <EditIcon htmlColor={'#fff'}/>
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={` ${product.name}`.trim()}
                                  secondary={`${product.price} руб. х ${(product.quantity|| 1)} = ${product.price * (product.quantity|| 1)} руб.`}/>
                </ListItem>
            ))}
        </List></>
}
export default Products;